"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountProfileSchema = void 0;
const zod_1 = require("zod");
const spoken_language_1 = require("./spoken-language");
const subject_preferences_1 = require("./subject-preferences");
const teaching_subject_1 = require("./teaching-subject");
const social_account_1 = require("./social-account");
const lingo2_models_1 = require("lingo2-models");
const work_experience_1 = require("./work-experience");
const education_school_1 = require("./education-school");
exports.AccountProfileSchema = zod_1.z.object({
  about: zod_1.z.string(),
  birth_date: zod_1.z.string().datetime().or(zod_1.z.date()),
  spoken_languages: zod_1.z.array(spoken_language_1.SpokenLanguageSchema).default([]),
  studying_subjects: zod_1.z.array(subject_preferences_1.SubjectPreferencesSchema).default([]),
  education_schools: zod_1.z.array(education_school_1.EducationSchoolSchema).default([]),
  education_docs: zod_1.z.array(zod_1.z.string()).default([]),
  teaching_subjects: zod_1.z.array(teaching_subject_1.TeachingSubjectSchema).default([]),
  social_accounts: zod_1.z.array(social_account_1.SocialAccountSchema).default([]),
  work_experience: zod_1.z.array(work_experience_1.WorkExperienceSchema).default([]),
  version: zod_1.z.number(),
  verification_status: zod_1.z.nativeEnum(lingo2_models_1.UserProfileVerificationEnum).default(lingo2_models_1.UserProfileVerificationEnum.not_verified),
  verification_comment: zod_1.z.string().optional(),
  verification_sent_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  verified_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  skype: zod_1.z.string().optional(),
  telegram: zod_1.z.string().optional()
});
